var tv4 = require('tv4');
var checkDecimals = require('./checks/decimals');
var checkDigits = require('./checks/digits');

var schema = require('./schema.json');

function check(settings) {
  
  var valid = tv4.validate(settings, schema);
  if (!valid) {
    throw new Error(tv4.error.message + ' @ ' + tv4.error.dataPath);
  }
  checkDecimals(settings);
  checkDigits(settings);
  return settings;
  
} 

module.exports = check;


//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/flowone-settings-check/index.js
// module id = 851
// module chunks = 0